import { prepareResponse, throwResponseError } from '@/helpers/apiHelpers/responseHelpers';
import { getSearchUsersByProxyApi } from '@/api/v1/recipient/getSearchUsersByProxyApi';

export const searchUsersByProxy = async (wireId: string, email: string) => {
  const payload = { email };

  try {
    const response = await getSearchUsersByProxyApi(wireId, payload);

    return prepareResponse(response);
  } catch (e) {
    throwResponseError(e);
  }
};
